/**
 * Libellés — espace Médecin chef.
 */

export const HEAD_DOCTOR_COPY = {
  LAYOUT: {
    NAVBAR_BRAND: 'Médecin chef',
    SIDE_MENU_SECTION: 'Médecin chef',
    SIDE_QUICK_ACCESS: 'Activité clinique',
    SIDE_MENU_CATALOGS: 'Catalogues & référentiels',
    SIDE_GROUP_EXAMENS: 'Examens & imagerie',
    SIDE_GROUP_EXAMENS_HINT: 'Analyses · radio · écho',
    SIDE_GROUP_REFERENTIAL: 'Référentiels cliniques',
    SIDE_GROUP_REFERENTIAL_HINT: 'Maladies · vaccins · arrêts',
    SIDE_GROUP_INFIRMERIE: 'Infirmerie',
    SIDE_GROUP_INFIRMERIE_HINT: 'Soins et tests',
    SIDE_GROUP_NETWORK: 'Réseau de soins',
    SIDE_GROUP_NETWORK_HINT: 'Partenaires · orientations',
    SIDE_GROUP_STATS: 'Statistiques & rapports',
    SIDE_GROUP_STATS_HINT: 'Synthèse · consultations · morbidité · infirmerie · examens',
    NO_SITE_ASSIGNED: 'Aucun site affecté au profil',
    SITE_CHIP_LABEL: 'Site',
    CHANGE_SITE_CHIP_TITLE: 'Changer le site de travail',
    CHANGE_SITE_MENU: 'Changer de site',
    SITE_GATE_BADGE: 'Ouverture de session clinique',
    SITE_GATE_TITLE: 'Choisir votre site de travail',
    SITE_GATE_DESC:
      'Sélectionnez le site clinique qui sera utilisé pour cette session. Les consultations, dossiers et prescriptions se chargeront ensuite sur ce site.',
    SITES_LOADING: 'Chargement des sites…',
    SITE_CARD_META_FALLBACK: 'Site clinique',
    SITE_CARD_CTA: 'Commencer',
    SITE_ACTIVE_TOAST: 'Site clinique actif : {name}',
    TOPBAR_TAGLINE:
      'Consultations · ordonnances · dossiers · référentiels et rendez-vous'
  },

  /**
   * Menu latéral (label + hint) — même mode textuel que réception / admin personnel.
   * Le hint complète le libellé sans le répéter.
   */
  NAV: {
    dashboard: {
      label: 'Tableau de bord',
      hint: 'Snapshot d’activité & actions rapides',
      icon: 'home'
    },
    dossier: {
      label: 'Dossier adhérent',
      hint: 'Historique médical & passages accueil',
      icon: 'user'
    },
    consultations: {
      label: 'Consultations',
      hint: 'File du site & filière médicale',
      icon: 'stethoscope'
    },
    prescriptions: {
      label: 'Ordonnances',
      hint: 'Rédaction & lien pharmacie',
      icon: 'pills'
    },
    maladies: {
      label: 'Maladies',
      hint: 'Référentiel · code & libellé',
      icon: 'alertCircle'
    },
    analyses: {
      label: 'Analyses médicales',
      hint: 'Catalogue des actes biologiques',
      icon: 'chartBar'
    },
    radiographies: {
      label: 'Radiographies',
      hint: 'Catalogue des actes d’imagerie',
      icon: 'desktop'
    },
    echographies: {
      label: 'Échographies',
      hint: 'Catalogue des actes échographiques',
      icon: 'heart'
    },
    partenaires: {
      label: 'Partenaires',
      hint: 'Hôpitaux, ophtalmo, pédiatrie, optique',
      icon: 'building'
    },
    orientations: {
      label: 'Orientations',
      hint: 'Catalogue des prises en charge partenaires',
      icon: 'arrowRight'
    },
    joursRepos: {
      label: 'Jours de repos',
      hint: 'Certificats d\'arrêt émis en consultation',
      icon: 'calendar'
    },
    soinsInfirmierie: {
      label: 'Soins infirmerie',
      hint: 'Catalogue des actes de soins',
      icon: 'heart'
    },
    testsInfirmierie: {
      label: 'Tests infirmerie',
      hint: 'Bandelettes, TDR, glycémie capillaire…',
      icon: 'check'
    },
    planificationFamiliale: {
      label: 'Planning familial',
      hint: 'Catalogue des actes de planification familiale',
      icon: 'heart'
    },
    vaccins: {
      label: 'Vaccins',
      hint: 'Catalogue vaccinal & schémas',
      icon: 'shield'
    },
    rendezVous: {
      label: 'Rendez-vous',
      hint: 'Planification & statuts',
      icon: 'calendar'
    },
    statistiquesSynthese: {
      label: 'Synthèse',
      hint: 'Indicateurs globaux du site',
      icon: 'home'
    },
    statistiquesConsultations: {
      label: 'Consultations',
      hint: 'Volumes, filières et praticiens',
      icon: 'stethoscope'
    },
    statistiquesPathologies: {
      label: 'Pathologies',
      hint: 'Maladies les plus diagnostiquées',
      icon: 'alertCircle'
    },
    statistiquesMorbidite: {
      label: 'Morbidité',
      hint: 'Répartition sexe × âge et hospitalisations',
      icon: 'chartBar'
    },
    statistiquesOrdonnances: {
      label: 'Ordonnances',
      hint: 'Volumes, statuts et prescripteurs',
      icon: 'pills'
    },
    statistiquesMedicaments: {
      label: 'Médicaments',
      hint: 'Principes actifs les plus prescrits',
      icon: 'chartBar'
    },
    statistiquesSoins: {
      label: 'Rapport infirmier',
      hint: 'Journal des actes + soins, tests, vaccins',
      icon: 'heart'
    },
    statistiquesExamens: {
      label: 'Examens',
      hint: 'Analyses, radio et échographies demandés',
      icon: 'desktop'
    },
    statistiquesWorkAccidents: {
      label: 'Accidents du travail',
      hint: 'Prises en charge classées AT',
      icon: 'alertCircle'
    },
    statistiquesOccupationalDiseases: {
      label: 'Maladies professionnelles',
      hint: 'Prises en charge classées MP',
      icon: 'alertCircle'
    },
    statistiquesRepos: {
      label: 'Jours de repos',
      hint: 'Certificats d\'arrêt et durées prescrites',
      icon: 'pause'
    }
  },

  ARIA_TOGGLE_MENU: 'Ouvrir le menu de navigation',
  ARIA_CLOSE_MENU: 'Fermer le menu de navigation',
  ARIA_TOGGLE_SIDEBAR: 'Réduire le menu latéral',
  ARIA_EXPAND_SIDEBAR: 'Développer le menu latéral',
  ARIA_USER_MENU: 'Menu du compte utilisateur',
  MOBILE_NAV_TITLE: 'Navigation',
  SIDEBAR_COLLAPSE: 'Réduire',
  SIDEBAR_EXPAND: 'Développer',

  /** Cartes hub — modules réellement disponibles (direction médicale). */
  HUB_CLINICAL_CARDS: [
    {
      kind: 'route',
      routeKey: 'DOSSIER',
      title: 'Dossier adhérent',
      subtitle: 'Historique médical & passages accueil',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'CONSULTATIONS',
      title: 'Consultations',
      subtitle: 'File du site sélectionné',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'PRESCRIPTIONS',
      title: 'Ordonnances',
      subtitle: 'Ordonnances numériques liées à la pharmacie',
      badge: 'ready',
      requiresPrescriber: true
    },
    {
      kind: 'newConsult',
      title: 'Nouvelle consultation',
      subtitle: 'Création rapide (même formulaire que la barre latérale)',
      badge: 'ready'
    }
  ],

  HUB_COORD_CARDS: [
    {
      kind: 'route',
      routeKey: 'MALADIES',
      title: 'Maladies',
      subtitle: 'Référentiel · code & libellé',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'ANALYSES',
      title: 'Analyses médicales',
      subtitle: 'Catalogue des examens biologiques',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'RADIOGRAPHIES',
      title: 'Radiographies',
      subtitle: "Catalogue des actes d'imagerie",
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'ECHOGRAPHIES',
      title: 'Échographies',
      subtitle: 'Catalogue des actes échographiques',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'PARTENAIRES',
      title: 'Partenaires de soins',
      subtitle: 'Hôpitaux et établissements partenaires',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'ORIENTATIONS',
      title: 'Orientations & prises en charge',
      subtitle: 'Ophtalmo, pédiatrie, lunettes, hôpital',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'JOURS_REPOS',
      title: 'Jours de repos',
      subtitle: 'Certificats d\'arrêt émis en consultation',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'SOINS_INFIRMERIE',
      title: 'Soins infirmerie',
      subtitle: 'Catalogue des actes de soins infirmiers',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'TESTS_INFIRMERIE',
      title: 'Tests infirmerie',
      subtitle: 'Tests rapides réalisés au poste infirmier',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'VACCINS',
      title: 'Vaccins',
      subtitle: 'Catalogue vaccinal institutionnel',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'PLANIFICATION_FAMILIALE',
      title: 'Planning familial',
      subtitle: 'Catalogue des actes de planification familiale',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'RENDEZ_VOUS',
      title: 'Rendez-vous',
      subtitle: 'Planification et suivi des statuts',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'STATISTIQUES',
      title: 'Statistiques & rapports',
      subtitle: 'Synthèse, pathologies, ordonnances et médicaments',
      badge: 'ready'
    }
  ],

  DASHBOARD: {
    BADGE: 'Médecin chef',
    TITLE: 'Tableau de bord',
    SUBTITLE:
      'Snapshot d’activité du site courant — indicateurs alignés sur la synthèse clinique, sur une période courte.',

    PRIMARY_TITLE: 'Actions prioritaires',
    PRIMARY_DESC: 'Démarrer une prise en charge ou ouvrir un dossier adhérent.',

    QUICK_NEW_CONSULT: 'Nouvelle consultation',
    QUICK_NEW_CONSULT_HINT: 'Création rapide sur le site courant',
    QUICK_FULL_CARE: 'Prise en charge complète',
    QUICK_FULL_CARE_HINT: 'Parcours consultation structuré',
    QUICK_DOSSIER: 'Dossier adhérent',
    QUICK_DOSSIER_HINT: 'Historique consolidé SMIE',

    PERIOD_ARIA: 'Période du tableau de bord',
    PERIOD_7D: '7 jours',
    PERIOD_30D: '30 jours',
    PERIOD_HINT: (from, to) => `${from} → ${to}`,
    SITE_REQUIRED: 'Sélectionnez un site de travail pour afficher l’activité.',
    ERROR_LOAD: 'Impossible de charger le snapshot d’activité.',

    STATS_TITLE: 'Indicateurs de la période',
    STATS_SUBTITLE: 'Données du site sélectionné, calculées comme dans les statistiques.',

    ACTIVITY_TITLE: 'Activité consolidée',
    ACTIVITY_DESC: (days, period) =>
      `Résumé sur ${days} jour${days > 1 ? 's' : ''}${period ? ` (${period})` : ''}.`,

    HIGHLIGHTS_TITLE: 'À retenir sur la période',
    HIGHLIGHTS_SUBTITLE: 'Classements rapides — maladies, prescriptions et praticiens les plus actifs.',
    TOP_SEE_ALL: 'Tout voir',
    TOP_PATHO_TITLE: 'Top 5 pathologies',
    TOP_PATHO_HINT: 'Par consultations concernées',
    TOP_PATHO_EMPTY: 'Aucune pathologie sur la période.',
    TOP_PATHO_META: (n) => `${Number(n || 0).toLocaleString('fr-FR')} consultation${n > 1 ? 's' : ''}`,
    TOP_MED_TITLE: 'Top 5 médicaments',
    TOP_MED_HINT: 'Par quantité prescrite',
    TOP_MED_EMPTY: 'Aucun médicament prescrit sur la période.',
    TOP_MED_META: (rx, unit) => {
      const rxLabel = `${Number(rx || 0).toLocaleString('fr-FR')} ordonnance${rx > 1 ? 's' : ''}`;
      return unit ? `${rxLabel} · ${unit}` : rxLabel;
    },
    TOP_DOCTOR_TITLE: 'Top 5 praticiens',
    TOP_DOCTOR_HINT: 'Par consultations prises en charge',
    TOP_DOCTOR_EMPTY: 'Aucun praticien identifié sur la période.',
    TOP_DOCTOR_ROLE: (role) => String(role || '').replace(/_/g, ' '),

    REPORTS_TITLE: 'Aller plus loin',
    REPORTS_SUBTITLE: 'Ouvrir les statistiques détaillées (période libre, société, morbidité…).',
    REPORTS_CTA_SYNTHESE: 'Voir la synthèse complète',
    REPORTS_CTA_SYNTHESE_HINT: 'Tableaux, graphiques et filtres avancés',
    REPORTS_CTA_CONSULT: 'Consultations',
    REPORTS_CTA_MORBIDITE: 'Morbidité',
    REPORTS_CTA_RX: 'Ordonnances',

    STAT_CONSULT_TOTAL: 'Consultations',
    STAT_CONSULT_PENDING: 'En attente',
    STAT_CONSULT_DONE: 'Terminées',
    STAT_AT: 'Accidents du travail',
    STAT_NURSING: 'Actes infirmiers',
    STAT_EXAMS: 'Examens',
    STAT_RX: 'Ordonnances',
    STAT_REST: 'Certificats de repos',
    STAT_RX_ACTIVE: 'Ordonnances actives'
  },

  REPORTS: {
    BADGE: 'Pilotage clinique',
    TITLE: 'Statistiques & rapports',
    DESCRIPTION:
      'Synthèse des pathologies diagnostiquées, volumes d’ordonnances et médicaments les plus prescrits sur la période.',
    CONTEXT_PREFIX: 'Périmètre :',
    FILTER_BAR_ARIA: 'Filtres des statistiques cliniques',
    FILTER_PERIOD: 'Raccourcis de période',
    FILTER_DATE_FROM: 'Du',
    FILTER_DATE_TO: 'Au',
    FILTER_SITE_SHORT: 'Site',
    FILTER_ALL_SITES: 'Tous les sites',
    FILTER_SITE: 'Site sélectionné',
    FILTER_SITE_ARIA: 'Filtrer par site',
    FILTER_COMPANY_SHORT: 'Société',
    FILTER_ALL_COMPANIES: 'Toutes les sociétés',
    FILTER_COMPANY: 'Société sélectionnée',
    FILTER_COMPANY_ARIA: 'Filtrer par société',
    PRESET_7D: '7 jours',
    PRESET_30D: '30 jours',
    PRESET_90D: '90 jours',
    PRESET_12M: '12 mois',
    REFRESH_LABEL: 'Actualiser',
    REFRESH_ARIA: 'Actualiser les statistiques',
    LOADING_OVERLAY: 'Mise à jour…',
    CONTEXT_REST_PEOPLE: 'personnes en repos',
    REST_PEOPLE_INSIGHT: 'personnes ont eu un repos sur la période',
    REST_PEOPLE_INSIGHT_MEMBERS: 'dont {n} adhérents SMIE',
    REST_PEOPLE_INSIGHT_ALL_MEMBERS: 'fiches adhérents SMIE',
    REST_PEOPLE_INSIGHT_CERTS: '{n} certificats',
    REST_PEOPLE_INSIGHT_DAYS: '{n} jours prescrits',
    LOADING: 'Chargement des indicateurs…',
    LOADING_CHARTS: 'Construction des graphiques…',
    ERROR_LOAD: 'Impossible de charger les statistiques cliniques.',
    SUB_NAV_ARIA: 'Sections des statistiques',
    SUB_SYNTHESE: 'Synthèse',
    PAGE_SYNTHESE_TITLE: 'Synthèse d’activité',
    PAGE_SYNTHESE_DESC:
      'Vue consolidée de la période : consultations par filière, AT/MP, actes infirmiers, examens, pathologies, ordonnances et repos.',
    SUB_CONSULTATIONS: 'Consultations',
    SUB_PATHOLOGIES: 'Pathologies',
    SUB_MORBIDITE: 'Morbidité',
    SUB_ORDONNANCES: 'Ordonnances',
    SUB_MEDICAMENTS: 'Médicaments',
    SUB_SOINS: 'Rapport infirmier',
    SUB_EXAMENS: 'Examens',
    SUB_REPOS: 'Jours de repos',
    SUB_WORK_ACCIDENTS: 'Accidents du travail',
    SUB_OCCUPATIONAL_DISEASES: 'Maladies professionnelles',
    PAGE_WORK_ACCIDENTS_TITLE: 'Rapport accidents du travail',
    PAGE_WORK_ACCIDENTS_DESC:
      'Prises en charge SMIE classées accident du travail (AT) — volumes et évolution sur la période, indépendamment du rapport consultations.',
    EMPTY_WORK_ACCIDENTS: 'Aucun accident du travail enregistré sur cette période.',
    PAGE_OCCUPATIONAL_DISEASES_TITLE: 'Rapport maladies professionnelles',
    PAGE_OCCUPATIONAL_DISEASES_DESC:
      'Prises en charge SMIE classées maladie professionnelle (MP) — volumes et évolution sur la période, indépendamment du rapport consultations.',
    EMPTY_OCCUPATIONAL_DISEASES: 'Aucune maladie professionnelle enregistrée sur cette période.',
    PAGE_REPOS_TITLE: 'Rapport jours de repos',
    PAGE_REPOS_DESC:
      'Certificats d\'arrêt émis en consultation sur la période sélectionnée (date de consultation). Les volumes et jours ne comptent que les certificats au statut émis.',
    PAGE_REPOS_VIEW_LIST: 'Voir les certificats',
    PAGE_REPOS_VIEW_LIST_HINT: 'Liste détaillée sur le site courant',
    PAGE_CONSULTATIONS_TITLE: 'Rapport consultations',
    PAGE_CONSULTATIONS_DESC:
      'Vue médecin : volumes par statut et filière, part médecine, accidents du travail, évolution et activité des praticiens.',
    PAGE_SOINS_TITLE: 'Rapport infirmier',
    PAGE_SOINS_DESC:
      'Même journal d’actes que le major : soins, injections, tests, vaccinations et planning familial — synthèses et classements sur la période.',
    PAGE_NURSING_JOURNAL_TITLE: 'Journal des actes infirmiers',
    PAGE_NURSING_JOURNAL_DESC:
      'Liste chronologique des actes : date, identité patient, société, type et détail (soin / injection / planning).',
    PAGE_OVERVIEW_TITLE: 'Journal des actes infirmiers',
    PAGE_OVERVIEW_DESC:
      'Liste chronologique des soins, injections, tests, vaccinations et actes de planning familial.',
    SECTION_NURSING_CARE_STATS: 'Statistiques — soins',
    SECTION_NURSING_INJECTION_STATS: 'Statistiques — injections',
    SECTION_NURSING_TEST_STATS: 'Statistiques — tests',
    SECTION_NURSING_VACCINE_STATS: 'Statistiques — vaccinations',
    SECTION_NURSING_FP_STATS: 'Statistiques — planning familial',
    SYNTHESIS_EXPORT: 'Export CSV',
    SYNTHESIS_EXPORTING: 'Export…',
    SYNTHESIS_PER_PAGE: 'Lignes/page',
    SYNTHESIS_PAGE_STATUS: (page, totalPages, total) =>
      `Page ${Number(page || 1)} / ${Number(totalPages || 1)} · ${Number(total || 0).toLocaleString('fr-FR')} lignes`,
    SYNTHESIS_COUNT: (count) =>
      `${Number(count || 0).toLocaleString('fr-FR')} acte${Number(count || 0) > 1 ? 's' : ''}`,
    COL_DATE: 'Date',
    COL_NOM: 'Nom',
    COL_PRENOM: 'Prénom',
    COL_SOCIETE: 'Société',
    COL_MATRICULE: 'Matricule',
    COL_TYPE: 'Type',
    COL_SEXE: 'Sexe',
    COL_AGE: 'Âge',
    COL_ACTE: 'Acte',
    COL_INJECTION: 'Injection',
    COL_PLANNING_FAMILIAL: 'Planning familial',
    EMPTY_SYNTHESIS: 'Aucun acte infirmier sur la période sélectionnée.',
    EMPTY_SYNTHESIS_HINT: 'Élargissez la période ou changez de site pour voir l’activité infirmière.',
    EMPTY_CLEAR_FILTERS: 'Effacer les filtres',
    ERROR_SYNTHESIS_LOAD: 'Impossible de charger le journal des actes.',
    RETRY_LABEL: 'Réessayer',
    PAGE_EXAMENS_TITLE: 'Rapport examens complémentaires',
    PAGE_EXAMENS_DESC:
      'Demandes d’analyses, radiographies et échographies — répartition par catégorie, statut et acte.',
    PAGE_PATHOLOGIES_TITLE: 'Rapport pathologies',
    PAGE_PATHOLOGIES_DESC:
      'Diagnostics codés en consultation : volumes, patients, évolution mensuelle, répartition par filière et classement des maladies.',
    PAGE_MORBIDITE_TITLE: 'Rapport de morbidité',
    PAGE_MORBIDITE_DESC:
      'Tableau officiel : maladies codées ventilées par sexe et tranches d’âge, avec total et hospitalisations (orientations hôpital).',
    PAGE_ORDONNANCES_TITLE: 'Rapport ordonnances',
    PAGE_ORDONNANCES_DESC:
      'Volumes d’ordonnances par statut (actives, remplies, annulées), évolution mensuelle et classements des prescripteurs.',
    PAGE_MEDICAMENTS_TITLE: 'Rapport médicaments',
    PAGE_MEDICAMENTS_DESC:
      'Médicaments les plus prescrits — fréquence, quantités totales et lignes d’ordonnance.',
    SYNTHESE_SECTION_TITLE: 'Accès rapide aux rapports',
    SYNTHESE_SECTION_DESC: 'Ouvrez le détail par thématique pour explorer les classements complets.',
    SYNTHESE_TABLE_TITLE: 'Tableau de synthèse',
    SYNTHESE_TABLE_DESC: (days, period) =>
      `Période${period ? ` ${period}` : ''} · ${Number(days || 1)} jour${Number(days || 1) > 1 ? 's' : ''} · moyennes = total ÷ jours`,
    SYNTHESE_COL_INDICATOR: 'Indicateur',
    SYNTHESE_COL_TOTAL: 'Total',
    SYNTHESE_COL_AVG_DAY: 'Moy. / jour',
    SYNTHESE_TABLE_SEC_VISITS: 'Consultations & filières',
    SYNTHESE_TABLE_SEC_RISKS: 'Risques professionnels',
    SYNTHESE_TABLE_SEC_NURSING: 'Soins infirmiers',
    SYNTHESE_TABLE_SEC_CLINICAL: 'Examens, pathologies & prescriptions',
    SYNTHESE_TABLE_SEC_REST: 'Repos médical',
    SYNTHESE_ROW_VISITS: 'Visites / consultations (toutes filières)',
    SYNTHESE_ROW_MEDICAL: 'Médecine générale',
    SYNTHESE_ROW_DENTAL: 'Dentaire',
    SYNTHESE_ROW_NURSING_LINE: 'Filière infirmerie',
    SYNTHESE_ROW_AT: 'Accidents du travail',
    SYNTHESE_ROW_MP: 'Maladies professionnelles',
    SYNTHESE_ROW_NURSING_VISITS: 'Consultations avec actes infirmiers',
    SYNTHESE_ROW_NURSING_ACTS: 'Total actes infirmiers',
    SYNTHESE_ROW_CARE: 'Soins',
    SYNTHESE_ROW_INJECTIONS: 'Injections',
    SYNTHESE_ROW_TESTS: 'Tests',
    SYNTHESE_ROW_VACCINES: 'Vaccinations',
    SYNTHESE_ROW_FP: 'Planning familial',
    SYNTHESE_ROW_EXAMS: 'Examens complémentaires',
    SYNTHESE_ROW_PATHOLOGIES: 'Pathologies distinctes',
    SYNTHESE_ROW_PATHO_CASES: 'Diagnostics codés',
    SYNTHESE_ROW_RX: 'Ordonnances',
    SYNTHESE_ROW_MEDS: 'Médicaments distincts',
    SYNTHESE_ROW_REST_CERT: 'Certificats de repos émis',
    SYNTHESE_ROW_REST_DAYS: 'Jours de repos prescrits',
    SYNTHESE_ROW_REST_PEOPLE: 'Personnes concernées',
    SYNTHESE_PATHOLOGIES_DESC: 'pathologies distinctes codées',
    SYNTHESE_ORDONNANCES_DESC: 'ordonnances émises',
    SYNTHESE_MEDICAMENTS_DESC: 'médicaments distincts prescrits',
    SYNTHESE_MORBIDITE_DESC: 'tableau sexe × âge',
    SYNTHESE_CONSULTATIONS_DESC: 'consultations enregistrées',
    COL_DOCTOR: 'Prescripteur',
    COL_PRACTITIONER: 'Praticien',
    COL_PRACTITIONER_ROLE: 'Rôle',
    KPI_CONSULTATIONS: 'Consultations',
    KPI_CONSULTATIONS_HINT: 'sur la période',
    KPI_PATHOLOGIES: 'Pathologies distinctes',
    KPI_PATHOLOGIES_HINT: 'consultations avec diagnostic codé',
    KPI_PATHOLOGY_RATE_HINT: 'des consultations codées',
    KPI_PATHO_OCCURRENCES: 'Diagnostics codés',
    KPI_PATHO_CONSULTATIONS: 'Consultations codées',
    KPI_PATHO_PATIENTS: 'Patients concernés',
    KPI_PRESCRIPTIONS: 'Ordonnances',
    KPI_PRESCRIPTIONS_HINT: 'délivrées à la pharmacie',
    KPI_MEDICATIONS: 'Médicaments distincts',
    KPI_MEDICATIONS_HINT: 'unités prescrites au total',
    COL_PATHOLOGY: 'Pathologie',
    COL_CODE: 'Code',
    COL_CONSULTATIONS: 'Consultations',
    COL_OCCURRENCES: 'Occurrences',
    COL_PATIENTS: 'Patients distincts',
    COL_SHARE: 'Part (%)',
    COL_CUMULATIVE: 'Cumul (%)',
    COL_MEDICATION: 'Médicament',
    COL_PRESCRIPTIONS: 'Ordonnances',
    COL_QUANTITY: 'Quantité totale',
    COL_LINES: 'Lignes',
    SECTION_STATUS: 'Par statut',
    SECTION_TREND: 'Évolution mensuelle',
    SECTION_DOCTORS: 'Prescripteurs les plus actifs',
    EMPTY_PATHOLOGIES: 'Aucune pathologie enregistrée sur cette période.',
    EMPTY_MORBIDITE: 'Aucune morbidité codée sur cette période.',
    ERROR_MORBIDITY_LOAD: 'Impossible de charger le rapport de morbidité.',
    KPI_MORBIDITE_DISEASES: 'Maladies',
    KPI_MORBIDITE_CASES: 'Cas codés',
    KPI_MORBIDITE_HOSP: 'Hospitalisations',
    KPI_MORBIDITE_HOSP_HINT: 'orientations hôpital',
    MORBIDITE_COL_CODE: 'Code',
    MORBIDITE_COL_MALADIES: 'Maladies',
    MORBIDITE_GROUP_M: 'Masculin',
    MORBIDITE_GROUP_F: 'Féminin',
    MORBIDITE_COL_TOTAL: 'Total',
    MORBIDITE_COL_HOSP: 'Hospitalisations',
    MORBIDITE_COL_HOSP_SHORT: 'Hosp.',
    MORBIDITE_PER_PAGE: 'Lignes/page',
    MORBIDITE_PAGE_STATUS: (page, totalPages, total) =>
      `Page ${Number(page || 1)} / ${Number(totalPages || 1)} · ${Number(total || 0).toLocaleString('fr-FR')} maladies`,
    MORBIDITE_FOOTNOTE:
      'Hospitalisations = consultations avec orientation hôpital. L’âge est calculé à la date de consultation (mois d’âge si date de naissance connue).',
    EMPTY_MEDICATIONS: 'Aucune prescription médicamenteuse sur cette période.',
    EMPTY_PRESCRIPTIONS: 'Aucune ordonnance sur cette période.',
    EMPTY_DOCTORS: 'Aucun prescripteur identifié.',
    TABLE_DETAIL_TITLE: 'Tableau statistique détaillé',
    TABLE_PATHOLOGIES_TITLE: 'Classement détaillé des pathologies',
    TABLE_DOCTORS_TITLE: 'Répartition par prescripteur',
    CHART_OTHERS: 'Autres',
    CHART_CONSULTATIONS: 'Consultations',
    CHART_PRESCRIPTIONS: 'Ordonnances',
    CHART_PRESCRIPTION_COUNT: 'Nombre d’ordonnances',
    CHART_AXIS_PERIOD: 'Période',
    CHART_AXIS_VOLUME: 'Volume',
    CHART_AXIS_COUNT: 'Effectif',
    CHART_AXIS_CONSULTATIONS: 'Nombre de consultations',
    CHART_AXIS_ORDONNANCES: 'Nombre d’ordonnances',
    CHART_AXIS_PRESCRIBERS: 'Prescripteurs',
    CHART_ACTIVITY_TITLE: 'Activité clinique mensuelle',
    CHART_ACTIVITY_DESC: 'Courbes comparatives consultations vs ordonnances (repère orthonormé).',
    CHART_RX_STATUS_TITLE: 'Répartition par statut',
    CHART_RX_STATUS_DESC: 'Diagramme circulaire des ordonnances selon leur statut.',
    CHART_RX_TREND_TITLE: 'Évolution mensuelle des ordonnances',
    CHART_RX_TREND_DESC: 'Tendance temporelle sur la période filtrée.',
    CHART_PATHO_SHARE_TITLE: 'Top pathologies',
    CHART_PATHO_SHARE_DESC: 'Part relative des 5 pathologies les plus fréquentes.',
    CHART_MED_TOP_TITLE: 'Médicaments les plus prescrits',
    CHART_MED_TOP_DESC: 'Histogramme horizontal — ordonnances par produit.',
    CHART_MED_HIST_DESC:
      'Histogramme vertical — top 10 des quantités prescrites. Survolez une barre pour voir les ordonnances.',
    CHART_AXIS_MEDICATION: 'Médicament',
    CHART_PATHO_BAR_TITLE: 'Dispersion des volumes (boxplot)',
    CHART_PATHO_BAR_DESC:
      'Boîte à moustaches — distribution mensuelle des consultations pour les principales pathologies.',
    CHART_PATHO_BOXPLOT_SERIES: 'Consultations / mois',
    CHART_PATHO_PIE_TITLE: 'Répartition des diagnostics',
    CHART_PATHO_PIE_DESC: 'Camembert — concentration des pathologies dominantes.',
    CHART_PATHO_TREND_TITLE: 'Évolution mensuelle',
    CHART_PATHO_TREND_DESC: 'Consultations codées et occurrences de diagnostics par mois.',
    CHART_PATHO_TREND_CONSULTATIONS: 'Consultations codées',
    CHART_PATHO_TREND_OCCURRENCES: 'Diagnostics codés',
    CHART_PATHO_LINE_TITLE: 'Par filière',
    CHART_PATHO_LINE_DESC: 'Consultations avec pathologie — médecine, dentaire, infirmerie.',
    CHART_MED_BAR_TITLE: 'Fréquence de prescription',
    CHART_MED_BAR_DESC: 'Top 10 médicaments par nombre d’ordonnances.',
    CHART_MED_PIE_TITLE: 'Part des ordonnances',
    CHART_MED_PIE_DESC: 'Camembert — part des 5 produits les plus prescrits.',
    CHART_MED_QTY_PIE_TITLE: 'Répartition des quantités',
    CHART_MED_QTY_PIE_DESC: 'Part des unités prescrites par produit (top 5).',
    CHART_DOCTORS_BAR_TITLE: 'Volume par prescripteur',
    CHART_DOCTORS_BAR_DESC:
      'Histogramme vertical — ordonnances émises par médecin, dentiste ou infirmier(ère).',
    CHART_CONSULT_STATUS_TITLE: 'Consultations par statut',
    CHART_CONSULT_STATUS_DESC: 'Camembert — en attente, terminées, annulées.',
    CHART_CONSULT_LINE_TITLE: 'Répartition par filière',
    CHART_CONSULT_LINE_DESC: 'Part médicale, dentaire et infirmerie.',
    CHART_CONSULT_TREND_TITLE: 'Évolution mensuelle',
    CHART_CONSULT_TREND_DESC: 'Courbe des consultations sur la période.',
    CHART_WORK_ACCIDENT_TREND_TITLE: 'Évolution mensuelle des AT',
    CHART_WORK_ACCIDENT_TREND_DESC: 'Nombre de prises en charge classées accident du travail par mois.',
    CHART_WORK_ACCIDENT_BAR_TITLE: 'Volume mensuel',
    CHART_WORK_ACCIDENT_BAR_DESC: 'Histogramme des accidents du travail déclarés en consultation.',
    CHART_WORK_ACCIDENTS: 'Accidents du travail',
    CHART_AXIS_WORK_ACCIDENTS: 'Nombre d\'AT',
    CHART_OCCUPATIONAL_DISEASE_TREND_TITLE: 'Évolution mensuelle des MP',
    CHART_OCCUPATIONAL_DISEASE_TREND_DESC:
      'Nombre de prises en charge classées maladie professionnelle par mois.',
    CHART_OCCUPATIONAL_DISEASE_BAR_TITLE: 'Volume mensuel',
    CHART_OCCUPATIONAL_DISEASE_BAR_DESC:
      'Histogramme des maladies professionnelles déclarées en consultation.',
    CHART_OCCUPATIONAL_DISEASES: 'Maladies professionnelles',
    CHART_AXIS_OCCUPATIONAL_DISEASES: 'Nombre de MP',
    CHART_CONSULT_DOCTORS_TITLE: 'Consultations par praticien',
    CHART_CONSULT_DOCTORS_DESC:
      'Histogramme — dossiers pris en charge par médecin, dentiste ou infirmier(ère).',
    CHART_NURSING_CARE: 'Actes de soins',
    CHART_NURSING_TESTS: 'Tests infirmiers',
    CHART_NURSING_VACCINES: 'Vaccinations',
    CHART_NURSING_CARE_BAR_TITLE: 'Top actes de soins',
    CHART_NURSING_CARE_BAR_DESC: 'Barres horizontales — soins les plus réalisés.',
    CHART_NURSING_CARE_PIE_TITLE: 'Répartition des soins',
    CHART_NURSING_CARE_PIE_DESC: 'Camembert — concentration des actes dominants.',
    CHART_NURSING_TEST_BAR_TITLE: 'Top tests infirmiers',
    CHART_NURSING_TEST_BAR_DESC: 'Bandelettes, TDR, glycémie… par fréquence.',
    CHART_NURSING_VACCINE_BAR_TITLE: 'Top vaccinations',
    CHART_NURSING_VACCINE_BAR_DESC: 'Vaccins administrés en infirmerie par fréquence.',
    CHART_NURSING_VACCINE_PIE_TITLE: 'Répartition des vaccins',
    CHART_NURSING_VACCINE_PIE_DESC: 'Camembert — vaccins les plus administrés.',
    CHART_NURSING_FAMILY_PLANNING: 'Planning familial',
    CHART_NURSING_FAMILY_PLANNING_BAR_TITLE: 'Top actes planning familial',
    CHART_NURSING_FAMILY_PLANNING_BAR_DESC: 'Actes de planning familial par fréquence.',
    CHART_NURSING_FAMILY_PLANNING_PIE_TITLE: 'Répartition planning familial',
    CHART_NURSING_FAMILY_PLANNING_PIE_DESC: 'Camembert — actes les plus réalisés.',
    CHART_EXAMS: 'Examens demandés',
    CHART_EXAM_ORDERS: 'Demandes d’examens',
    CHART_EXAM_CATEGORY_TITLE: 'Par type d’examen',
    CHART_EXAM_CATEGORY_DESC: 'Analyses · radiographies · échographies.',
    CHART_EXAM_STATUS_TITLE: 'Par statut de demande',
    CHART_EXAM_STATUS_DESC: 'Demandé · réalisé · annulé.',
    CHART_EXAM_TREND_TITLE: 'Évolution mensuelle',
    CHART_EXAM_TREND_DESC: 'Courbe des prescriptions d’examens.',
    CHART_EXAM_BAR_TITLE: 'Examens les plus demandés',
    CHART_EXAM_BAR_DESC: 'Classement par acte du catalogue.',
    CHART_EXAM_PIE_TITLE: 'Part des examens',
    CHART_EXAM_PIE_DESC: 'Camembert — top 5 actes vs autres.',
    CHART_AXIS_ACTIONS: 'Nombre d’actes',
    CHART_AXIS_RESULTS: 'Nombre de résultats',
    CHART_AXIS_EXAMS: 'Nombre de demandes',
    KPI_CONSULT_PENDING: 'En attente',
    KPI_CONSULT_DONE: 'Terminées',
    KPI_CONSULT_CANCELLED: 'Annulées',
    KPI_CONSULT_MEDICAL: 'Filière médecine',
    KPI_CONSULT_NURSING: 'Passages infirmerie',
    KPI_RX_TOTAL: 'Ordonnances',
    KPI_RX_ACTIVE: 'Actives',
    KPI_RX_FULFILLED: 'Remplies',
    KPI_RX_CANCELLED: 'Annulées',
    KPI_WORK_ACCIDENTS: 'Accidents du travail',
    KPI_WORK_ACCIDENTS_HINT: 'prises en charge classées AT',
    KPI_OCCUPATIONAL_DISEASES: 'Maladies professionnelles',
    KPI_OCCUPATIONAL_DISEASES_HINT: 'prises en charge classées MP',
    KPI_NURSING_VISITS: 'Consultations avec actes',
    KPI_NURSING_CARE: 'Actes de soins',
    KPI_NURSING_INJECTIONS: 'Injections',
    KPI_NURSING_TESTS: 'Tests réalisés',
    KPI_NURSING_VACCINES: 'Vaccinations',
    KPI_NURSING_FAMILY_PLANNING: 'Planning familial',
    KPI_EXAM_ORDERS: 'Demandes d’examens',
    KPI_EXAM_TYPES: 'Actes distincts',
    COL_NURSING_CARE: 'Acte de soin',
    COL_NURSING_INJECTION: 'Injection',
    COL_NURSING_TEST: 'Test infirmerie',
    COL_NURSING_VACCINE: 'Vaccin',
    COL_NURSING_FAMILY_PLANNING: 'Acte planning familial',
    COL_ADMINISTRATIONS: 'Administrations',
    COL_ACTIONS: 'Actes',
    COL_RESULTS: 'Résultats',
    COL_EXAM: 'Examen',
    COL_EXAM_CATEGORY: 'Catégorie',
    COL_EXAM_ORDERS: 'Demandes',
    EMPTY_CONSULTATIONS: 'Aucune consultation sur cette période.',
    EMPTY_NURSING: 'Aucun acte infirmier enregistré sur cette période.',
    EMPTY_NURSING_CARE: 'Aucun soin infirmier enregistré.',
    EMPTY_NURSING_INJECTIONS: 'Aucune injection enregistrée.',
    EMPTY_NURSING_TESTS: 'Aucun test infirmier enregistré.',
    EMPTY_NURSING_VACCINES: 'Aucune vaccination enregistrée.',
    EMPTY_NURSING_FAMILY_PLANNING: 'Aucun acte de planning familial enregistré.',
    EMPTY_EXAMS: 'Aucune demande d’examen sur cette période.',
    TABLE_DOCTORS_CONSULT_TITLE: 'Classement des praticiens (consultations)',
    TABLE_NURSING_CARE_TITLE: 'Détail des actes de soins',
    TABLE_NURSING_INJECTION_TITLE: 'Détail des injections',
    TABLE_NURSING_TEST_TITLE: 'Détail des tests infirmiers',
    TABLE_NURSING_VACCINE_TITLE: 'Détail des vaccinations',
    TABLE_NURSING_FAMILY_PLANNING_TITLE: 'Détail planning familial',
    TABLE_EXAM_TITLE: 'Détail des examens demandés',
    SYNTHESE_CONSULTATIONS_DESC: 'consultations enregistrées',
    SYNTHESE_WORK_ACCIDENTS_DESC: 'accidents du travail (AT)',
    SYNTHESE_OCCUPATIONAL_DISEASES_DESC: 'maladies professionnelles (MP)',
    SYNTHESE_SOINS_DESC: 'actes infirmiers (soins, tests, vaccins…)',
    SYNTHESE_EXAMENS_DESC: 'demandes d’examens',
    SYNTHESE_REPOS_DESC: 'personnes distinctes avec repos médical',
    CHART_NURSING_INJECTION_PIE_TITLE: 'Répartition des injections',
    CHART_NURSING_INJECTION_PIE_DESC: 'Camembert — injections les plus réalisées.',
    CHART_REST_CERTIFICATES: 'Certificats émis',
    CHART_REST_DAYS_TOTAL: 'Jours de repos',
    CHART_REST_STATUS_TITLE: 'Par statut',
    CHART_REST_STATUS_DESC: 'Certificats émis vs annulés.',
    CHART_REST_TREND_TITLE: 'Évolution mensuelle',
    CHART_REST_TREND_DESC:
      'Évolution mensuelle des certificats émis, des adhérents distincts (axe gauche) et des jours prescrits (axe droit).',
    CHART_REST_DURATION_TITLE: 'Durée des arrêts',
    CHART_REST_DURATION_DESC: 'Répartition par tranche de jours (certificats émis).',
    CHART_REST_DOCTORS_TITLE: 'Jours prescrits par médecin',
    CHART_REST_DOCTORS_DESC: 'Volume total de jours de repos par prescripteur.',
    CHART_AXIS_CERTIFICATES: 'Nombre de certificats',
    CHART_AXIS_REST_DAYS: 'Jours prescrits',
    KPI_REST_CERTIFICATES: 'Certificats émis',
    KPI_REST_UNIQUE_MEMBERS: 'Adhérents concernés',
    KPI_REST_UNIQUE_MEMBERS_HINT: 'fiches SMIE distinctes avec certificat émis',
    CHART_REST_UNIQUE_MEMBERS: 'Personnes distinctes',
    KPI_REST_CANCELLED: 'Annulés',
    KPI_REST_IN_PROGRESS: 'En cours',
    KPI_REST_DAYS: 'Jours prescrits',
    KPI_REST_IN_PROGRESS_HINT: 'arrêt incluant aujourd\'hui',
    KPI_REST_AVG: 'Durée moyenne',
    KPI_REST_AVG_HINT: 'jours par certificat émis',
    COL_REST_CERTIFICATES: 'Certificats',
    COL_REST_DAYS: 'Jours prescrits',
    COL_REST_DURATION: 'Tranche de durée',
    DURATION_BUCKET_1_3: '1 à 3 jours',
    DURATION_BUCKET_4_7: '4 à 7 jours',
    DURATION_BUCKET_8_14: '8 à 14 jours',
    DURATION_BUCKET_15_PLUS: '15 jours et +',
    EMPTY_REST_DAYS: 'Aucun certificat de repos sur cette période.',
    TABLE_REST_DOCTORS_TITLE: 'Détail par médecin prescripteur'
  },

  /** Référentiel maladies — direction médicale. */
  DISEASES: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Référentiel des maladies',
    PAGE_SUBTITLE:
      'Codes et libellés utilisés dans les diagnostics de consultation — alimentent le champ maladie du dossier clinique.',
    NEW_BUTTON: 'Nouvelle maladie',
    MODAL_TITLE_NEW: 'Ajouter une maladie',
    MODAL_TITLE_EDIT: 'Modifier la maladie',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Code unique et libellé affiché lors de la saisie du diagnostic en consultation.',
    MODAL_SUBTITLE_EDIT:
      'Ajustez le code ou le nom — les consultations déjà enregistrées gardent leur référence.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le référentiel',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_CODE: 'Code maladie',
    FIELD_CODE_PLACEHOLDER: 'Ex. I10',
    FIELD_CODE_HINT: 'Code court · majuscules automatiques · 20 caractères max.',
    FIELD_NAME: 'Nom de la maladie',
    FIELD_NAME_PLACEHOLDER: 'Ex. Hypertension artérielle essentielle',
    SEARCH_PLACEHOLDER: 'Rechercher par code ou libellé…',
    STAT_TOTAL: 'Total référentiel',
    STAT_SHOWN: 'Affichées',
    STAT_SHOWN_HINT: 'Après filtre de recherche',
    REFRESH_ARIA: 'Actualiser le référentiel',
    LOADING: 'Chargement des maladies…',
    EMPTY_TITLE: 'Aucune maladie',
    EMPTY: 'Le référentiel est vide ou ne correspond pas à votre recherche.',
    RESULTS_LABEL: 'entrée(s)',
    COL_CODE: 'Code',
    COL_NAME: 'Libellé',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_DELETE: 'Supprimer',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…'
  },

  /** Catalogue examens (analyses, radiographies, échographies). */
  EXAM_CATALOG: {
    BADGE: 'Médecin chef',
    NEW_BUTTON: 'Ajouter au catalogue',
    SEARCH_PLACEHOLDER: 'Rechercher libellé ou description…',
    FILTER_COVERAGE: 'Prise en charge',
    FILTER_FAMILY: 'Domaine de biologie',
    FILTER_FAMILY_ALL: 'Tous les domaines',
    FILTER_FAMILY_ALL_SHORT: 'Tous',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichées',
    STAT_ACTIVE: 'Actives',
    STAT_INACTIVE: 'Inactives',
    RESULTS_LABEL: 'entrée(s)',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucune entrée',
    EMPTY: 'Le catalogue est vide ou ne correspond pas à vos filtres.',
    COL_EXAM: 'Acte du catalogue',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_ACTIVATE: 'Activer',
    ACTION_DEACTIVATE: 'Désactiver',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Nouvelle entrée catalogue',
    MODAL_TITLE_EDIT: 'Modifier l\'entrée',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Libellé, prise en charge et paramètres cliniques — visible lors de la prescription d\'examens.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour l\'acte — les demandes déjà émises conservent leur libellé d\'origine.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le catalogue',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_LABEL: 'Libellé',
    FIELD_LABEL_PLACEHOLDER: 'Nom complet de l\'examen',
    FIELD_COVERAGE: 'Type de prise en charge',
    FIELD_FAMILY: 'Domaine de biologie',
    FIELD_FAMILY_PLACEHOLDER: 'Sélectionner un domaine',
    FIELD_DESCRIPTION: 'Description',
    FIELD_DESCRIPTION_PLACEHOLDER: 'Indications, protocole ou remarques cliniques',
    FIELD_ACTIVE: 'Entrée active dans le catalogue',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Référentiel partenaires de soins. */
  PARTNERS: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Partenaires de soins',
    PAGE_SUBTITLE:
      'Hôpitaux, ophtalmologie, pédiatrie et optique — établissements référencés pour les orientations depuis la consultation.',
    NEW_BUTTON: 'Nouveau partenaire',
    SEARCH_PLACEHOLDER: 'Rechercher nom, adresse ou contact…',
    FILTER_TYPE: 'Type de partenaire',
    FILTER_TYPE_ALL: 'Tous',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichés',
    STAT_ACTIVE: 'Actifs',
    STAT_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'partenaire(s)',
    REFRESH_ARIA: 'Actualiser le référentiel',
    LOADING: 'Chargement des partenaires…',
    EMPTY_TITLE: 'Aucun partenaire',
    EMPTY: 'Le référentiel est vide ou ne correspond pas à vos filtres.',
    LIST_ARIA: 'Liste des partenaires de soins',
    ACTION_EDIT: 'Modifier',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Ajouter un partenaire',
    MODAL_TITLE_EDIT: 'Modifier le partenaire',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Nom, type et coordonnées — proposé lors des orientations hôpital, ophtalmo, pédiatrie ou lunettes.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour la fiche — les orientations déjà émises conservent le libellé d\'origine.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le référentiel',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_NAME: 'Nom de l\'établissement',
    FIELD_NAME_PLACEHOLDER: 'Ex. CHU Joseph Raseta Befelatanana',
    FIELD_TYPE: 'Type de partenaire',
    FIELD_ADDRESS: 'Adresse',
    FIELD_ADDRESS_PLACEHOLDER: 'Rue, quartier, ville…',
    FIELD_PHONE: 'Téléphone',
    FIELD_PHONE_PLACEHOLDER: 'Ex. +261 20 22 123 45',
    FIELD_EMAIL: 'E-mail',
    FIELD_EMAIL_PLACEHOLDER: 'contact@etablissement.mg',
    FIELD_NOTES: 'Notes internes',
    FIELD_NOTES_PLACEHOLDER: 'Horaires, contact privilégié, remarques…',
    FIELD_ACTIVE: 'Partenaire actif dans le référentiel',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Catalogue orientations & prises en charge. */
  REFERRAL_CATALOG: {
    BADGE: 'Médecin chef',
    NEW_BUTTON: 'Ajouter au catalogue',
    SEARCH_PLACEHOLDER: 'Rechercher libellé ou description…',
    FILTER_COVERAGE: 'Prise en charge',
    FILTER_CATEGORY: 'Catégorie',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichées',
    STAT_ACTIVE: 'Actives',
    STAT_INACTIVE: 'Inactives',
    RESULTS_LABEL: 'acte(s)',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucun acte',
    EMPTY: 'Le catalogue est vide ou ne correspond pas à vos filtres.',
    LIST_ARIA: 'Liste des actes d\'orientation',
    ACTION_EDIT: 'Modifier',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Nouvel acte d\'orientation',
    MODAL_TITLE_EDIT: 'Modifier l\'acte',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Libellé, prise en charge SMIE/CMC et partenaire par défaut — proposé lors de la prescription en consultation.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour l\'acte — les orientations déjà émises conservent leur libellé d\'origine.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le catalogue',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_LABEL: 'Libellé',
    FIELD_LABEL_PLACEHOLDER: 'Nom de l\'acte ou de la prise en charge',
    FIELD_COVERAGE: 'Type de prise en charge',
    FIELD_PARTNER: 'Partenaire par défaut',
    FIELD_PARTNER_NONE: '— Aucun partenaire —',
    FIELD_DESCRIPTION: 'Description',
    FIELD_DESCRIPTION_PLACEHOLDER: 'Indications, protocole ou remarques cliniques',
    FIELD_ACTIVE: 'Acte actif dans le catalogue',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Certificats de jours de repos — suivi direction médicale. */
  REST_DAYS: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Jours de repos',
    PAGE_SUBTITLE:
      'Certificats médicaux d\'arrêt émis depuis les consultations — filtrés par le site de travail sélectionné en barre supérieure.',
    NO_SITE:
      'Sélectionnez un site de travail dans la barre supérieure pour afficher les certificats de ce site.',
    SITE_HINT: 'Certificats sur le site actif',
    SEARCH_PLACEHOLDER: 'Patient, médecin ou motif médical…',
    FILTER_STATUS: 'Statut',
    FILTER_STATUS_ALL: 'Tous',
    FILTER_STATUS_ISSUED: 'Émis',
    FILTER_STATUS_CANCELLED: 'Annulés',
    FILTER_PERIOD: 'Période d\'arrêt',
    FILTER_DATE_FROM: 'Du',
    FILTER_DATE_TO: 'Au',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Résultats',
    STAT_SHOWN_HINT: 'Après filtres actifs',
    STAT_ISSUED_SITE: 'Émis sur le site',
    STAT_TOTAL_DAYS: 'Jours d\'arrêt',
    STAT_TOTAL_DAYS_HINT: 'Cumul des certificats émis',
    STAT_IN_PROGRESS: 'En cours',
    STAT_IN_PROGRESS_HINT: 'Arrêt incluant aujourd\'hui',
    RESULTS_LABEL: 'certificat(s)',
    REFRESH_ARIA: 'Actualiser la liste',
    LOADING: 'Chargement des certificats…',
    EMPTY_TITLE: 'Aucun certificat',
    EMPTY: 'Aucun certificat ne correspond à vos critères sur ce site.',
    LIST_ARIA: 'Liste des certificats de jours de repos',
    ACTION_VIEW: 'Voir le certificat',
    ACTION_OPEN: 'Ouvrir la consultation',
    STATUS_ISSUED: 'Émis',
    STATUS_CANCELLED: 'Annulé',
    IN_PROGRESS_BADGE: 'En cours',
    CONSULT_PREFIX: 'Consult.',
    DAYS_SUFFIX: 'j'
  },

  /** Catalogue soins infirmiers. */
  NURSING_CARE_CATALOG: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Catalogue des soins infirmiers',
    PAGE_SUBTITLE:
      'Référentiel des actes proposés en infirmerie — pansements, surveillance et premiers soins.',
    NEW_BUTTON: 'Nouvel acte de soin',
    SEARCH_PLACEHOLDER: 'Rechercher un libellé…',
    FILTER_TYPE: 'Type de soin',
    FILTER_TYPE_ALL: 'Tous',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichés',
    STAT_ACTIVE: 'Actifs',
    STAT_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'acte(s)',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucun acte',
    EMPTY: 'Le catalogue est vide ou ne correspond pas à vos filtres.',
    LIST_ARIA: 'Liste des actes de soins infirmiers',
    COL_TYPE: 'Type',
    COL_LABEL: 'Libellé',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_DEACTIVATE: 'Désactiver',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Nouvel acte de soin',
    MODAL_TITLE_EDIT: 'Modifier l\'acte de soin',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Libellé, type et protocole suggéré — proposé lors de la saisie des soins au poste infirmier.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour l\'acte — les passages déjà enregistrés conservent leur libellé d\'origine.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le catalogue',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_TYPE: 'Type de soin',
    FIELD_NEW_TYPE_OPTION: 'Nouveau type…',
    FIELD_NEW_TYPE_LABEL: 'Libellé du nouveau type',
    FIELD_NEW_TYPE_PLACEHOLDER: 'Ex. Suture, Perfusion…',
    FIELD_NEW_TYPE_HINT: 'Un type inexistant sera ajouté au référentiel lors de l’enregistrement.',
    FIELD_LABEL: 'Libellé',
    FIELD_LABEL_PLACEHOLDER: 'Ex. Pansement simple stérile',
    FIELD_DESCRIPTION: 'Description par défaut',
    FIELD_DESCRIPTION_PLACEHOLDER: 'Protocole, matériel ou remarques cliniques',
    FIELD_TREATMENT: 'Traitement suggéré',
    FIELD_TREATMENT_PLACEHOLDER: 'Ex. Bétadine + compresse stérile',
    FIELD_SORT_ORDER: 'Ordre d\'affichage',
    FIELD_SORT_HINT: 'Plus petit = affiché en premier dans les listes infirmières.',
    FIELD_ACTIVE: 'Acte actif dans le catalogue',
    SORT_PREFIX: 'Ordre',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Catalogue injections infirmerie. */
  NURSING_INJECTION_CATALOG: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Catalogue des injections infirmerie',
    PAGE_SUBTITLE:
      'Actes d’injection et préparations injectables réalisés au poste infirmier.',
    NEW_BUTTON: 'Nouvelle injection',
    SEARCH_PLACEHOLDER: 'Rechercher un libellé…',
    FILTER_TYPE: 'Type d’injection',
    FILTER_TYPE_ALL: 'Tous',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichés',
    STAT_ACTIVE: 'Actifs',
    STAT_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'injection(s)',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucune injection',
    EMPTY: 'Le catalogue est vide ou ne correspond pas à vos filtres.',
    LIST_ARIA: 'Liste des injections infirmerie',
    COL_TYPE: 'Type',
    COL_LABEL: 'Libellé',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_DEACTIVATE: 'Désactiver',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Nouvelle injection',
    MODAL_TITLE_EDIT: 'Modifier l\'injection',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Libellé et paramètres suggérés — proposés lors de la saisie d’injections au poste infirmier.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour l\'injection — les passages déjà enregistrés conservent leur libellé d\'origine.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le catalogue',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_TYPE: 'Type d\'injection',
    FIELD_NEW_TYPE_OPTION: 'Nouveau type…',
    FIELD_NEW_TYPE_LABEL: 'Libellé du nouveau type',
    FIELD_NEW_TYPE_PLACEHOLDER: 'Ex. IM, IV, SC…',
    FIELD_NEW_TYPE_HINT: 'Un type inexistant sera ajouté au référentiel lors de l’enregistrement.',
    FIELD_LABEL: 'Libellé',
    FIELD_LABEL_PLACEHOLDER: 'Ex. Injection intramusculaire de vitamine',
    FIELD_DESCRIPTION: 'Description par défaut',
    FIELD_DESCRIPTION_PLACEHOLDER: 'Protocole, matériel ou remarques cliniques',
    FIELD_TREATMENT: 'Traitement suggéré',
    FIELD_TREATMENT_PLACEHOLDER: 'Ex. Produit, dose, voie d’administration…',
    FIELD_SORT_ORDER: 'Ordre d\'affichage',
    FIELD_SORT_HINT: 'Plus petit = affiché en premier dans les listes infirmières.',
    FIELD_ACTIVE: 'Injection active dans le catalogue',
    SORT_PREFIX: 'Ordre',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Catalogue planning familial. */
  FAMILY_PLANNING_CATALOG: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Catalogue planning familial',
    PAGE_SUBTITLE:
      'Referentiel des actes de planification familiale realises au poste infirmier.',
    NEW_BUTTON: 'Nouvel acte',
    SEARCH_PLACEHOLDER: 'Rechercher un libelle…',
    FILTER_INACTIVE: 'Inclure les inactifs',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucun acte',
    EMPTY: 'Le catalogue est vide ou ne correspond pas a vos filtres.',
    COL_LABEL: 'Libelle',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_DEACTIVATE: 'Desactiver',
    MODAL_TITLE_NEW: 'Nouvel acte',
    MODAL_TITLE_EDIT: 'Modifier l\'acte',
    MODAL_MODE_NEW: 'Creation',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_LABEL: 'Libelle',
    FIELD_LABEL_PLACEHOLDER: 'Ex. Conseil contraceptif, DIU, implant…',
    FIELD_ACTIVE: 'Acte actif dans le catalogue',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre a jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Catalogue vaccins. */
  VACCINE_CATALOG: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Catalogue des vaccins',
    PAGE_SUBTITLE:
      'Référentiel vaccinal SMIE — calendrier, voyage, professionnel : doses, rappels et protocoles d\'administration.',
    NEW_BUTTON: 'Nouveau vaccin',
    SEARCH_PLACEHOLDER: 'Rechercher un libellé…',
    FILTER_TYPE: 'Classification médicale',
    FILTER_TYPE_ALL: 'Tous',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichés',
    STAT_ACTIVE: 'Actifs',
    STAT_SCHEMA: 'Avec schéma',
    STAT_SCHEMA_HINT: 'doses / rappel',
    STAT_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'vaccin(s)',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucun vaccin',
    EMPTY: 'Le catalogue est vide ou ne correspond pas à vos filtres.',
    LIST_ARIA: 'Liste des vaccins du catalogue',
    COL_LABEL: 'Libellé',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_DEACTIVATE: 'Désactiver',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Nouveau vaccin',
    MODAL_TITLE_EDIT: 'Modifier le vaccin',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Libellé, type et schéma posologique — proposé lors de l\'enregistrement des vaccinations en consultation.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour le vaccin — les vaccinations déjà enregistrées conservent leur libellé d\'origine.',
    MODAL_SECTION_IDENTITY: 'Identification',
    MODAL_SECTION_SCHEMA: 'Schéma posologique',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le catalogue',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_TYPE: 'Classification médicale',
    FIELD_LABEL: 'Libellé',
    FIELD_LABEL_PLACEHOLDER: 'Ex. Pentavalent (DTC-Hib-HepB)',
    FIELD_DESCRIPTION: 'Description / protocole',
    FIELD_DESCRIPTION_PLACEHOLDER: 'Indications, contre-indications, remarques',
    FIELD_DEFAULT_DOSE: 'Dose par défaut',
    FIELD_DEFAULT_DOSE_PLACEHOLDER: 'Ex. 0,5 ml IM',
    FIELD_DOSES_IN_SERIES: 'Doses du schéma',
    FIELD_BOOSTER_MONTHS: 'Rappel (mois)',
    FIELD_SORT_ORDER: 'Ordre d\'affichage',
    FIELD_SORT_HINT: 'Plus petit = affiché en premier dans les listes.',
    FIELD_ACTIVE: 'Vaccin actif dans le catalogue',
    SORT_PREFIX: 'Ordre',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Catalogue tests infirmerie. */
  NURSING_TEST_CATALOG: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Catalogue des tests infirmerie',
    PAGE_SUBTITLE:
      'Bandelettes, glycémie capillaire, TDR… tests réalisés au poste infirmier, distincts des analyses laboratoire.',
    NEW_BUTTON: 'Nouveau test',
    SEARCH_PLACEHOLDER: 'Rechercher un libellé…',
    FILTER_TYPE: 'Type de test',
    FILTER_TYPE_ALL: 'Tous',
    FILTER_INACTIVE: 'Inclure les inactifs',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichés',
    STAT_ACTIVE: 'Actifs',
    STAT_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'test(s)',
    REFRESH_ARIA: 'Actualiser le catalogue',
    LOADING: 'Chargement du catalogue…',
    EMPTY_TITLE: 'Aucun test',
    EMPTY: 'Le catalogue est vide ou ne correspond pas à vos filtres.',
    LIST_ARIA: 'Liste des tests infirmerie',
    COL_LABEL: 'Libellé',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    ACTION_EDIT: 'Modifier',
    ACTION_DEACTIVATE: 'Désactiver',
    ACTION_DELETE: 'Supprimer',
    MODAL_TITLE_NEW: 'Nouveau test infirmerie',
    MODAL_TITLE_EDIT: 'Modifier le test',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Libellé, type et format de résultat — proposé lors de la saisie des tests au poste infirmier.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour le test — les résultats déjà enregistrés conservent leur libellé d\'origine.',
    MODAL_PREVIEW_LABEL: 'Aperçu dans le catalogue',
    MODAL_CLOSE_ARIA: 'Fermer le formulaire',
    FIELD_TYPE: 'Type de test',
    FIELD_LABEL: 'Libellé',
    FIELD_LABEL_PLACEHOLDER: 'Ex. Glycémie capillaire',
    FIELD_DESCRIPTION: 'Description',
    FIELD_DESCRIPTION_PLACEHOLDER: 'Méthode, matériel ou remarques',
    FIELD_RESULT_UNIT: 'Unité / format du résultat',
    FIELD_RESULT_UNIT_PLACEHOLDER: 'Ex. mmol/L, Positif / Négatif',
    FIELD_INSTRUCTIONS: 'Consignes par défaut',
    FIELD_INSTRUCTIONS_PLACEHOLDER: 'Ex. Jeûn de 8 h, lecture à 15 secondes…',
    FIELD_SORT_ORDER: 'Ordre d\'affichage',
    FIELD_SORT_HINT: 'Plus petit = affiché en premier dans les listes infirmières.',
    FIELD_ACTIVE: 'Test actif dans le catalogue',
    SORT_PREFIX: 'Ordre',
    BTN_CREATE: 'Ajouter',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif'
  },

  /** Planification rendez-vous — direction médicale. */
  APPOINTMENTS: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Rendez-vous médicaux',
    PAGE_SUBTITLE:
      'Planification, disponibilités des praticiens, transitions de statut et vue calendrier.',
    NEW_BUTTON: 'Nouveau rendez-vous',
    SEARCH_PLACEHOLDER: 'Référence, patient, motif…',
    FILTER_STATUS: 'Statut',
    FILTER_STATUS_ALL: 'Tous',
    FILTER_DOCTOR: 'Médecin',
    FILTER_DOCTOR_ALL: 'Tous les médecins',
    FILTER_DATE_FROM: 'Du',
    FILTER_DATE_TO: 'Au',
    FILTER_RESET: 'Réinitialiser les filtres',
    STAT_SHOWN: 'Affichés',
    STAT_PENDING: 'En attente',
    STAT_CONFIRMED: 'Confirmés',
    STAT_DONE: 'Terminés',
    RESULTS_LABEL: 'rdv',
    REFRESH_ARIA: 'Actualiser la liste',
    LOADING: 'Chargement des rendez-vous…',
    EMPTY_TITLE: 'Aucun rendez-vous',
    EMPTY: 'Aucun rendez-vous ne correspond à vos filtres.',
    LIST_ARIA: 'Liste des rendez-vous médicaux',
    UPCOMING_BADGE: 'À venir',
    PRIORITY_URGENT: 'Urgent',
    STATUS_EN_ATTENTE: 'En attente',
    STATUS_CONFIRME: 'Confirmé',
    STATUS_TERMINE: 'Terminé',
    STATUS_ANNULE: 'Annulé',
    STATUS_ABSENT: 'Absent',
    ACTION_VIEW: 'Voir le détail',
    ACTION_EDIT: 'Modifier',
    ACTION_CONFIRM: 'Confirmer',
    ACTION_FINISH: 'Terminer',
    ACTION_CANCEL: 'Annuler',
    ACTION_ABSENT: 'Marquer absent',
    CALENDAR_TITLE: 'Vue calendrier',
    CALENDAR_HINT: 'Créneaux groupés par jour selon les filtres médecin et période.',
    CALENDAR_EMPTY: 'Aucun créneau dans la période sélectionnée.',
    MODAL_TITLE_NEW: 'Planifier un rendez-vous',
    MODAL_TITLE_EDIT: 'Modifier le rendez-vous',
    MODAL_MODE_NEW: 'Création',
    MODAL_MODE_EDIT: 'Modification',
    MODAL_SUBTITLE_NEW:
      'Choisissez le praticien, le créneau et le patient — la disponibilité est vérifiée automatiquement.',
    MODAL_SUBTITLE_EDIT:
      'Mettez à jour le créneau ou le patient — l\'historique des statuts est conservé.',
    MODAL_SECTION_SLOT: 'Créneau & praticien',
    MODAL_SECTION_PATIENT: 'Patient',
    MODAL_SECTION_DETAILS: 'Motif clinique',
    MODAL_CLOSE_ARIA: 'Fermer',
    FIELD_DOCTOR: 'Médecin',
    FIELD_DOCTOR_PLACEHOLDER: 'Sélectionner…',
    FIELD_START: 'Début',
    FIELD_END: 'Fin',
    FIELD_PATIENT_TYPE: 'Type de patient',
    PATIENT_SMIE: 'Adhérent SMIE / ayant droit',
    PATIENT_EXTERNAL: 'Membre externe',
    FIELD_PATIENT_SEARCH: 'Recherche patient',
    FIELD_PATIENT_SEARCH_PLACEHOLDER: 'Nom, prénom, matricule…',
    PATIENT_SEARCH_LOADING: 'Recherche en cours…',
    FIELD_MOTIF: 'Motif',
    FIELD_MOTIF_PLACEHOLDER: 'Motif de consultation',
    FIELD_NOTES: 'Notes internes',
    FIELD_NOTES_PLACEHOLDER: 'Remarques pour l\'accueil ou le praticien…',
    AVAILABILITY_OK: 'Créneau disponible pour ce médecin.',
    AVAILABILITY_CONFLICT: 'Créneau indisponible — chevauchement détecté.',
    BTN_CREATE: 'Créer',
    BTN_UPDATE: 'Mettre à jour',
    BTN_CANCEL: 'Annuler',
    BTN_SAVE: 'Enregistrement…',
    BTN_CONFIRM: 'Valider',
    DETAIL_BADGE: 'Détail',
    DETAIL_TITLE: 'Rendez-vous',
    DETAIL_UNAVAILABLE: 'Détail indisponible.',
    DETAIL_PATIENT: 'Patient',
    DETAIL_DOCTOR: 'Médecin',
    DETAIL_SLOT: 'Créneau',
    DETAIL_MOTIF: 'Motif',
    DETAIL_NOTES: 'Notes',
    DETAIL_STATUS: 'Statut',
    DETAIL_HISTORY: 'Historique',
    DETAIL_HISTORY_EMPTY: 'Aucun événement enregistré.',
    CONFIRM_TITLE: 'Confirmer l\'action',
    CONFIRM_HINT: 'Cette action mettra à jour le statut du rendez-vous.',
    CONFIRM_CANCEL_REASON: 'Motif d\'annulation'
  },

  /** Liste des consultations — direction médicale. */
  CONSULTATIONS: {
    BADGE: 'Médecin chef',
    PAGE_TITLE: 'Consultations médicales',
    PAGE_SUBTITLE:
      'File d’attente et suivi des prises en charge sur le site sélectionné en barre supérieure.',
    SITE_HINT:
      'Le site de travail est celui affiché en haut de page ; la liste est filtrée automatiquement.',
    NEW_BUTTON: 'Nouvelle consultation',
    FILTER_PATIENT: 'Patient',
    FILTER_PATIENT_PLACEHOLDER: 'Nom du patient…',
    FILTER_STATUS: 'Statut',
    FILTER_DATE_FROM: 'Du',
    FILTER_DATE_TO: 'Au',
    FILTER_RESET: 'Réinitialiser les filtres',
    EMPTY: 'Aucune consultation ne correspond à ces critères sur ce site.',
    NO_SITE:
      'Sélectionnez un site de travail dans la barre supérieure pour afficher la file et les dossiers.',
    PRIMARY_ACTION: 'Ouvrir la fiche clinique',
    QUEUE_BADGE: 'À prendre en charge',
    STATUS_ALL: 'Tous les statuts',
    STATUS_QUEUE: 'File d\'attente',
    STATUS_IN_PROGRESS: 'En cours',
    STATUS_PENDING: 'En attente',
    STATUS_COMPLETED: 'Terminées',
    STATUS_CANCELLED: 'Annulées',
    ACTION_EDIT: 'Ouvrir la fiche clinique',
    ACTION_CANCEL: 'Clôturer sans prise en charge',
    ACTION_DELETE: 'Supprimer définitivement',
    COL_DATE: 'Date',
    COL_PATIENT: 'Patient',
    COL_LINE: 'Filière',
    COL_VITALS: 'Constantes',
    COL_AGE: 'Âge',
    COL_GENDER: 'Genre',
    COL_DIAGNOSIS: 'Diagnostic',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    STAT_TOTAL: 'Total affiché',
    STAT_IN_PROGRESS: 'En cours',
    STAT_COMPLETED: 'Terminées',
    STAT_QUEUE: 'File d\'attente',
    STAT_QUEUE_HINT: 'Sans médecin assigné',
    STAT_IN_PROGRESS_HINT: 'Prise en charge démarrée',
    REFRESH_ARIA: 'Actualiser la liste',
    LOADING: 'Chargement des consultations…',
    EMPTY_TITLE: 'Aucune consultation',
    RESULTS_LABEL: 'résultat(s)',
    FILTER_PERIOD: 'Période'
  },

  /** Éditeur consultation plein écran. */
  CONSULTATION_EDITOR: {
    BADGE: 'Médecin chef',
    BACK_LIST: 'Retour aux consultations',
    NEW: 'Nouvelle consultation',
    TITLE_NEW: 'Nouvelle consultation médicale',
    TITLE_EDIT: 'Fiche de consultation',
    SUBTITLE_NEW:
      'Identifiez l’adhérent par matricule ou saisissez un patient hors fiche, puis documentez l’examen.',
    SUBTITLE_EDIT: 'Complétez le compte rendu clinique et l’ordonnance si nécessaire.',
    DIRECT_VITALS_HINT:
      'Prise en charge directe : vous pouvez saisir les constantes vitales et l’examen clinique sur la même fiche.',
    RX_PANEL_TITLE: 'Ordonnance médicale',
    RX_PANEL_NEW_HINT:
      'Après enregistrement de la consultation, l’ordonnancier s’affiche ici pour la prescription et la clôture du dossier.',
    EXAM_PANEL_TITLE: 'Examens complémentaires',
    EXAM_PANEL_HINT:
      'Analyses, radiographies, échographies et orientations partenaires prescrites depuis le référentiel (SMIE / CMC).',
    REFERRAL_PANEL_TITLE: 'Orientations & prises en charge',
    REFERRAL_PANEL_HINT:
      'Hôpital, ophtalmo, pédiatrie, lunettes — catalogue partenaires SMIE / CMC.',
    REST_DAYS_PANEL_TITLE: 'Jours de repos',
    REST_DAYS_PANEL_HINT:
      'Certificat d\'arrêt de travail : date de début, durée, motif et impression PDF.',
    NURSING_PANEL_TITLE: 'Soins, tests & constantes',
    NURSING_PANEL_HINT:
      'Actes infirmiers, tests rapides, vaccins et relevés de constantes sur la consultation.',
    VACCINATION_PANEL_TITLE: 'Vaccinations',
    VACCINATION_PANEL_HINT:
      'Enregistrement des vaccins administrés — dose, lot et carnet vaccinal.',
    PATIENT_CONTEXT_LABEL: 'Patient en consultation',
    STATUS_CHIP_PENDING: 'En cours',
    STATUS_CHIP_COMPLETED: 'Terminée',
    STATUS_CHIP_CANCELLED: 'Annulée',
    WORK_ACCIDENT_LABEL: 'Accident du travail',
    WORK_ACCIDENT_YES: 'Oui',
    WORK_ACCIDENT_NO: 'Non',
    WORK_ACCIDENT_HINT: 'À renseigner si la prise en charge est liée à un AT déclaré.',
    WORK_ACCIDENT_LOCATION_LABEL: 'Lieu de l\'accident',
    WORK_ACCIDENT_LOCATION_WORK: 'Sur le travail',
    WORK_ACCIDENT_LOCATION_COMMUTE: 'Sur le trajet',
    WORK_ACCIDENT_SEVERITY_LABEL: 'Gravité',
    WORK_ACCIDENT_SEVERITY_ATG: 'ATG',
    WORK_ACCIDENT_SEVERITY_ATB: 'ATB',
    WORK_ACCIDENT_MODAL_TITLE: 'Accident du travail',
    WORK_ACCIDENT_MODAL_INTRO: 'Confirmez la prise en charge AT et précisez le lieu et la gravité.',
    WORK_ACCIDENT_MODAL_CONFIRM: 'Confirmer l\'AT',
    WORK_ACCIDENT_MODAL_CANCEL: 'Annuler',
    WORK_ACCIDENT_SUMMARY_EDIT: 'Modifier',
    OCCUPATIONAL_DISEASE_LABEL: 'Maladie professionnelle',
    OCCUPATIONAL_DISEASE_YES: 'Oui',
    OCCUPATIONAL_DISEASE_NO: 'Non',
    OCCUPATIONAL_DISEASE_HINT:
      'À renseigner si la prise en charge est liée à une maladie professionnelle déclarée.'
  }
};
